if($('.type-page, type-post, .type-category, .type-detail').length){
    var currentUrl = window.location.pathname;
    $.each(urlToClassMap, function(url, properties) {
       
            if (currentUrl.includes(url)) {
                $('body').addClass(properties.class);
                $('.site-name img').attr('src', properties.logo);
                if (properties.underFooter) {
                    $('#content-wrapper').after($('.content-wrapper .'+properties.underFooter))
                }
            }
        

        if($('.heroTop').length){
            $('header#header').after($('.heroTop'))
        }
    });
}